export default function CommunicationStandortHint() {
  return (
    <div className="rounded-md border border-destructive/40 bg-destructive/5 px-3 py-2 text-xs text-destructive">
      Kommunikationsvorlagen konnten nicht geladen werden: Ungueltiger Standort.
    </div>
  );
}
